import { Experiment, ExperimentSlim } from 'src/services';
import { PermittedRouteMap } from 'src/app-routes';
import { Dispatch } from '../../types';

export interface StepControls {
  canContinue: boolean;
  isSubmitting: boolean;
  onSubmit: () => Promise<boolean>;
}

export interface ExperimentWizardProps {
  shopId: number;
  experiment: Experiment | ExperimentSlim | undefined;
  dispatch: Dispatch;
  permittedRouteMap: PermittedRouteMap;
  onClose: () => void;
  hasRunningExperiment?: boolean;
  runningExperimentId?: string;
  onLaunched: (experimentId: string) => void;
}

export const WIZARD_STEPS = [
  { step: 1, label: 'Goal' },
  { step: 2, label: 'What to test' },
  { step: 3, label: 'Variants' },
  { step: 4, label: 'Traffic' },
  { step: 5, label: 'Review' },
] as const;
